// @givmo/app-charity — where "Turn on" goes for THIS person, decided ONCE (shell contract v3).
//
// The switched-off tile's affordance, the setting-up tile's door and the module gate's "Turn on"
// all ask the same question: may this person flip the organization's switch? The answer is the
// `write_settings` CAPABILITY off the ONE standing read — never a tier (the build law) — and, for a
// hook module, whether this host mounted an activation handler (`moduleTurnOnHref`). Written once so
// the popup and the gate cannot disagree.

import { CAPABILITY_WRITE_SETTINGS, holdsCapability, moduleTurnOnHref } from '@givmo/org-console';
import { useCharityConsole } from './charity-console-context';
import { ORG_ROUTE } from './console-routes';
import { BOOKS_SLUG } from '@givmo/books';
import { isBooksModuleEnabled } from '../lib/env';

const BOOKS_HANDLERS: readonly string[] = [BOOKS_SLUG];
const NO_HANDLERS: readonly string[] = [];

/** The same build knob mounts the Books route and the Apps-page handler. */
export function activationHandlers(): readonly string[] {
  return isBooksModuleEnabled() ? BOOKS_HANDLERS : NO_HANDLERS;
}

/** Whether this person may flip the organization's switches — a capability, read off the standing read. */
export function useCanTurnOn(): boolean {
  const { read } = useCharityConsole();
  return holdsCapability(read.capabilities, CAPABILITY_WRITE_SETTINGS);
}

/** The Admin Console's Apps page for a holder of `write_settings` (and a mounted handler), else `null`. */
export function useTurnOnHref(slug: string): string | null {
  const canTurnOn = useCanTurnOn();
  return canTurnOn ? moduleTurnOnHref(slug, ORG_ROUTE, activationHandlers()) : null;
}
